module.exports = __webpack_public_path__ + "img/基于人工智能大数据驱动，构建成都自媒体供需匹配闭环生态， 助力品牌价值与内容创作的精准转化.fcbb3d9d.png";